module.exports = false;



// WEBPACK FOOTER //
// node_modules/core-js/modules/_library.js